// src/components/common/LoadingSpinner.jsx
/**
 * LoadingSpinner Component
 * 
 * Reusable loading indicator component with customizable size and text.
 * Displays an animated spinning circle with optional loading message.
 * 
 * Functions:
 * - sizeClasses: Object mapping size props to CSS classes for different spinner sizes
 */

import React from 'react';

const LoadingSpinner = ({ 
  size = 'md', 
  className = '',
  text = 'Loading...' 
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12'
  };

  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <div className={`animate-spin rounded-full border-b-2 border-blue-600 ${sizeClasses[size]}`}></div>
      {text && (
        <p className="mt-2 text-sm text-gray-600">{text}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;